import {
  Directive,
  OnInit,
  ViewContainerRef,
  ComponentFactoryResolver,
  TemplateRef,
  Input,
  ComponentFactory,
  ComponentRef,
  OnChanges,
  SimpleChanges,
  Renderer,
  ElementRef,
} from '@angular/core';
import { SpinnerCoreComponent } from '../core/spinner.component';

@Directive({
  selector: '[cmSpinner]',
})
export class SpinnerDirective implements OnInit, OnChanges {

  @Input() cmSpinner = false;
  spinnerComponentFactory: ComponentFactory<SpinnerCoreComponent>;
  spinnerComponentInstance: ComponentRef<SpinnerCoreComponent>;

  constructor(
    private container: ViewContainerRef,
    private template: TemplateRef<any>,
    private resolver: ComponentFactoryResolver,
    private renderer: Renderer,
    private element: ElementRef,
  ) {}

  ngOnInit(): void {
    this.spinnerComponentFactory = this.resolver.resolveComponentFactory(SpinnerCoreComponent);
    this.renderTemplate();
    this.renderSpinner();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cmSpinner && !changes.cmSpinner.firstChange) {
      this.renderSpinner();
    }
  }

  atualizarDisplayInput(tipoDisplay) {
    this.renderer.setElementStyle(this.element.nativeElement.nextSibling, 'display', tipoDisplay);
  }

  atualizarStyleSpinner() {
    const spinnerSize = this.spinnerComponentInstance.instance.size;
    const spinnerElement = this.spinnerComponentInstance.location.nativeElement.firstChild;
    this.renderer.setElementStyle(spinnerElement, 'position', 'relative');
    this.renderer.setElementStyle(spinnerElement, 'top', `${spinnerSize * 0.25}`);
    this.renderer.setElementStyle(spinnerElement, 'margin-left', `-${spinnerSize * 1.5}`);
  }

  renderTemplate() {
    this.container.createEmbeddedView(this.template);
  }

  renderSpinner() {
    if (this.cmSpinner) {
      this.spinnerComponentInstance = this.container.createComponent(this.spinnerComponentFactory);
      this.spinnerComponentInstance.instance.size = 20;
      this.atualizarStyleSpinner();
      this.atualizarDisplayInput('inline-block');
    } else if (this.spinnerComponentInstance) {
      this.spinnerComponentInstance.destroy();
      this.atualizarDisplayInput('block');
    }
  }
}
